import { render, staticRenderFns } from "./OrdersAndArticles.vue?vue&type=template&id=8fcd429a&scoped=true"
import script from "./OrdersAndArticles.vue?vue&type=script&lang=js"
export * from "./OrdersAndArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcd429a",
  null
  
)

export default component.exports